import { c as e } from "react/compiler-runtime";
import { createContext as t, useContext as n } from "react";
import { jsx as r } from "react/jsx-runtime";
//#region src/router-context.ts
var i = t(null);
function a() {
	let e = n(i);
	if (!e) throw Error("`compatibility-router` hooks and components must be used inside <RouterProvider>");
	return e;
}
//#endregion
//#region src/link.tsx
function o(e) {
	return e.metaKey || e.ctrlKey || e.shiftKey || e.altKey;
}
function s(t) {
	let n = e(27), i, s, c, l, u, d, f;
	n[0] === t ? (i = n[1], s = n[2], c = n[3], l = n[4], u = n[5], d = n[6], f = n[7]) : ({to: f, params: c, search: u, onClick: s, target: d, children: i, ...l} = t, n[0] = t, n[1] = i, n[2] = s, n[3] = c, n[4] = l, n[5] = u, n[6] = d, n[7] = f);
	let { buildHref: p, recognize: m, navigate: h } = a(), g;
	n[8] !== p || n[9] !== c || n[10] !== u || n[11] !== f ? (g = p({
		to: f,
		params: c,
		search: u
	}), n[8] = p, n[9] = c, n[10] = u, n[11] = f, n[12] = g) : g = n[12];
	let _ = g, v;
	n[13] !== h || n[14] !== s || n[15] !== c || n[16] !== m || n[17] !== u || n[18] !== d || n[19] !== f ? (v = function(e) {
		s?.(e), !e.defaultPrevented && e.button === 0 && (o(e) || d && d !== "_self" || m(f) && (e.preventDefault(), h({
			to: f,
			params: c,
			search: u
		})));
	}, n[13] = h, n[14] = s, n[15] = c, n[16] = m, n[17] = u, n[18] = d, n[19] = f, n[20] = v) : v = n[20];
	let y = v, b;
	return n[21] !== i || n[22] !== y || n[23] !== _ || n[24] !== l || n[25] !== d ? (b = /* @__PURE__ */ r("a", {
		...l,
		href: _,
		onClick: y,
		target: d,
		children: i
	}), n[21] = i, n[22] = y, n[23] = _, n[24] = l, n[25] = d, n[26] = b) : b = n[26], b;
}
//#endregion
//#region src/router-provider.tsx
function c(t) {
	let n = e(7), { children: a, navigate: o, buildHref: s, recognize: c } = t, l;
	n[0] !== s || n[1] !== o || n[2] !== c ? (l = {
		navigate: o,
		buildHref: s,
		recognize: c
	}, n[0] = s, n[1] = o, n[2] = c, n[3] = l) : l = n[3];
	let u;
	return n[4] !== a || n[5] !== l ? (u = /* @__PURE__ */ r(i, {
		value: l,
		children: a
	}), n[4] = a, n[5] = l, n[6] = u) : u = n[6], u;
}
//#endregion
//#region src/use-navigate.ts
function l() {
	let t = e(4), { buildHref: n, recognize: r, navigate: i } = a(), o;
	return t[0] !== n || t[1] !== i || t[2] !== r ? (o = function(e) {
		let { to: t, params: a, search: o, replace: s } = e, c = n({
			to: t,
			params: a,
			search: o
		});
		if (!r(t)) {
			if (s) {
				window.location.replace(c);
				return;
			}
			window.location.assign(c);
			return;
		}
		i({
			to: t,
			params: a,
			search: o,
			replace: s
		});
	}, t[0] = n, t[1] = i, t[2] = r, t[3] = o) : o = t[3], o;
}
//#endregion
export { s as Link, c as RouterProvider, l as useNavigate };
